<template>
  <div class="home-container">
    <div class="loading-indicator" v-if="$store.state.datatable.loading">
      <b-spinner variant="primary" label="Large Spinner"/>
    </div>
    <SearchBar />

    <!-- Data table -->
  	<DataTable />
    <Detail/>
    <FilterSetting />
    <Fetch/>
  </div>
</template>

<script>
import Detail from '@/components/Detail'
import SearchBar from '@/components/SearchBar'
import DataTable from '@/components/DataTable'

export default {
  name: 'home',
  components: {
  	SearchBar,
  	DataTable,
    Detail,
    // Detail: () => import('@/components/Detail'),
    Fetch: () => import('@/components/fetchModal'),
    FilterSetting: () => import('@/components/FilterSetting')
  },
  created(){
    const self = this
    self.$store.dispatch('toggleSidebar', true)
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
        window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    showFetch(){
      return this.$store.getters['datatable/getModalFetch']
    },
    showDetail() {
      return this.$store.getters['datatable/isDetailShown']
    },
    showFilter() {
      return this.$store.getters['filter/isFilterShown']
    }
  },
  watch: {
    showFetch(value){
      if (value) {
        this.$bvModal.show('fetch-modal')
      } else {
        this.$bvModal.hide('fetch-modal')
      }
    },
    showFilter(value) {
      if (value) {
        this.$bvModal.show('filter-modal')
      } else {
        this.$bvModal.hide('filter-modal')
      }
    }
  }
}
</script>

<style lang="scss">
@import "~/assets/scss/layouts/default.scss";
</style>
